{
  "annuity": "Annuity",
  "brokerage-account": "Brokerage Account",
  "cryptocurrency": "Cryptocurrency",
  "defined-benefit-plan": "Defined Benefit Plan",
  "health-savings-account": "Health Savings Account",
  "ira": "IRA",
  "minor-ira": "Minor IRA",
  "minor-roth-ira": "Minor Roth IRA",
  "private-stock": "Private Stock",
  "profit-sharing-account": "Profit Sharing Account",
  "qualified-tuition-plan-529": "Qualified Tuition Plan 529",
  "roth-ira": "Roth IRA",
  "roth-401(k)": "Roth 401(k)",
  "simple-ira": "SIMPLE IRA",
  "simplified-employee-pension": "Simplified Employee Pension",
  "stock-option": "Stock Option",
  "401(k)": "401(k)",
  "tax-sheltered-annuity-403(b)": "403(b) Tax Sheltered Annuity ",
  "universal-trust-for-minor": "Universal Trust for Minor",
  "deferred-compensation-plan-457(b)": "457(b)",

  "annuities": "Annuities",
  "brokerage-accounts": "Brokerage Accounts",
  "cryptocurrencies": "Cryptocurrencies",
  "defined-benefit-plans": "Defined Benefit Plans",
  "health-savings-accounts": "Health Savings Accounts",
  "iras": "IRAs",
  "minor-iras": "Minor IRAs",
  "minor-roth-iras": "Minor Roth IRAs",
  "private-stocks": "Private Stocks",
  "profit-sharing-accounts": "Profit Sharing Accounts",
  "qualified-tuition-plan-529s": "Qualified Tuition Plan 529s",
  "roth-iras": "Roth IRAs",
  "roth-401(k)s": "Roth 401(k)s",
  "simple-iras": "SIMPLE IRAs",
  "simplified-employee-pensions": "Simplified Employee Pensions",
  "stock-options": "Stock Options",
  "401(k)s": "401(k)s",
  "tax-sheltered-annuities-403(b)": "403(b) Tax Sheltered Annuities ",
  "universal-trusts-for-minor": "Universal Trusts for Minor",
  "deferred-compensation-plan-457(b)s": "457(b)s",

  "beneficiary-information-label": "Beneficiary Information",
  "beneficiary-information-helper": "Record the account's primary and contingent beneficiary designations.",
  "beneficiary-information-preview-helper": "Preview only—use fictional details. Changes for up to 3 accounts are stored in this browser for 7 days.",
  "beneficiary-information-placeholder": "Add beneficiaries, percentages, or review notes.",
  "beneficiary-information-empty": "No beneficiary information added yet.",

  "after-tax-savings-contributions-sum-table-title": "After-Tax Savings",
  "after-tax-savings-contributions-sum-table-sum-title": "Total Annual Savings",

  "education-savings-contributions-sum-table-title": "Education Savings",
  "education-savings-contributions-sum-table-sum-title": "Total Annual Savings",

  "pre-tax-savings-contributions-sum-table-title": "Pre-Tax Savings",
  "pre-tax-savings-contributions-sum-table-sum-title": "Total Annual Savings",

  "private-stock-sum-table-title": "Private Stock",
  "private-stock-sum-table-sum-title": "Total Private Stock",

  "investment-mix-dont-know": "Don't Know",
  "investment-mix-very-conservative": "Very Conservative",
  "investment-mix-conservative": "Conservative",
  "investment-mix-moderate": "Moderate",
  "investment-mix-moderate-growth": "Moderate Growth",
  "investment-mix-balanced": "Balanced",
  "investment-mix-balanced-growth": "Balanced Growth",
  "investment-mix-growth": "Growth",
  "investment-mix-aggressive-growth": "Aggressive Growth",
  "investment-mix-equity-growth": "Equity Growth",

  "investment-mix-ratio-dont-know": "0/0",
  "investment-mix-ratio-very-conservative": "0/100",
  "investment-mix-ratio-conservative": "30/70",
  "investment-mix-ratio-moderate": "40/60",
  "investment-mix-ratio-moderate-growth": "50/50",
  "investment-mix-ratio-balanced": "60/40",
  "investment-mix-ratio-balanced-growth": "70/30",
  "investment-mix-ratio-growth": "80/20",
  "investment-mix-ratio-aggressive-growth": "90/10",
  "investment-mix-ratio-equity-growth": "100/0"
}
